module.exports = __webpack_public_path__ + "img/20121850003502.5289fae6.png";